const asArray = value => (Array.isArray(value) ? value : []);

export const lifecycleAllStagesFromSettings = settings => {
  if (Object.prototype.hasOwnProperty.call(settings, 'lifecycle_all_stages')) {
    return Boolean(settings.lifecycle_all_stages);
  }

  // Backward compatibility: older lifecycle flow settings represented
  // "all stages" with an empty destination list.
  return !asArray(settings.lifecycle_stage_ids).length;
};

export const isLifecycleTriggerConfigurationValid = ({
  triggerType,
  allStages,
  stageIds,
  triggerWhenCleared,
}) =>
  triggerType !== 'lifecycle_updated' ||
  Boolean(allStages) ||
  asArray(stageIds).length > 0 ||
  Boolean(triggerWhenCleared);

export const serializeLifecycleTriggerSettings = ({
  allStages,
  stageIds,
  triggerWhenCleared,
}) => ({
  lifecycle_all_stages: Boolean(allStages),
  lifecycle_stage_ids: allStages ? [] : asArray(stageIds),
  lifecycle_trigger_when_cleared: Boolean(triggerWhenCleared),
});
